import React, { useCallback, useEffect, useState } from "react";

import { Link, useHistory } from "react-router-dom";
import Select from "react-select";
import Swal from "sweetalert2";
import Switch from "react-switch";

import { BrComerceApiService } from "../../../../services/BrComerceApiService";
import debounce from "../../../../utils/debounce";
import formatCep from "../../../../utils/FormatCep";
import Loading from "../../../home/components/Loading";
import Container from "../../components/Container";
import store from "../../../../store/store";

import { FaCirclePlus } from "react-icons/fa6";
import {
  FiChevronLeft,
  FiChevronRight,
} from "react-icons/fi";

import styles from "./zipcodeRange.module.scss";

export const selectStyle = {
  control: styles => ({
    ...styles,
    backgroundColor: "inherit",
    width: "100%",
    border: "none",
    boxShadow: "none",
    outline: "none",
    color: "#807E80",
    padding: "0",
    "&:hover": {
      borderColor: "none"
    },
    cursor: "pointer"
  }),
  container: styles => ({
    ...styles,
    width: "40%",
    height: "51px",
    outline: "none",
    border: "1px solid #c1c1c1",
    borderRadius: "12px",
    padding: "6px 8px",
    cursor: "pointer",
    marginBottom: "20px"
  }),
  indicatorSeparator: styles => ({
    ...styles,
    display: "none",
    border: "none"
  }),
  option: (styles, { isSelected }) => ({
    ...styles,
    fontSize: "14px",
    fontFamily: "Mulish",
    fontWeight: 400,
    color: isSelected ? "#fff" : "#807E80",
    "&:hover": {
      backgroundColor: "#c1c1c1",
      color: "#fff",
      cursor: "pointer"
    },

    backgroundColor: isSelected ? "#409e6a" : "#fff"
  }),
  singleValue: styles => ({
    ...styles,
    color: "#807E80",
    fontSize: "14px"
  }),
  placeholder: styles => ({
    ...styles,
    fontSize: "14px",
    fontFamily: "Mulish",
    fontWeight: 400,
    color: "#807E80",
    whiteSpace: "nowrap"
  })
};

const selectPageStyle = {
  control: styles => ({
    ...styles,
    backgroundColor: "inherit",
    width: "100%",
    border: "none",
    boxShadow: "none",
    outline: "none",
    color: "#807E80",
    padding: "0",
    "&:hover": {
      borderColor: "none"
    },
    maxHeight: "48px",
    cursor: "pointer"
  }),
  container: styles => ({
    ...styles,
    minWidth: "56px",
    outline: "none",
    borderBottom: "1px solid #4D4D4D",
    padding: "0",
    cursor: "pointer"
  }),
  indicatorSeparator: styles => ({
    ...styles,
    display: "none",
    border: "none"
  }),
  option: (styles, { isSelected }) => ({
    ...styles,
    fontSize: "14px",
    fontFamily: "Mulish",
    fontWeight: 400,
    color: isSelected ? "#fff" : "#807E80",
    "&:hover": {
      backgroundColor: "#c1c1c1",
      color: "#color: #333333;",
      cursor: "pointer"
    },
    backgroundColor: isSelected ? "#409e6a" : "#fff"
  }),
  valueContainer: styles => ({
    ...styles,
    padding: "0"
  }),
  dropdownIndicator: styles => ({
    ...styles,
    padding: "0",
    color: "#4D4D4D"
  })
};

export const typesOptions = [
  {
    label: "Super Expresso",
    value: 1
  },
  {
    label: "Ultra Expresso",
    value: 2
  },
  {
    label: "Entrega Hoje",
    value: 3662
  },
];

export const ufsOptions = [
  {
    label: "Selecione",
    value: ""
  },
  {
    label: "AC",
    value: "AC",
  },
  {
    label: "AL",
    value: "AL",
  },
  {
    label: "AP",
    value: "AP",
  },
  {
    label: "AM",
    value: "AM",
  },
  {
    label: "BA",
    value: "BA",
  },
  {
    label: "CE",
    value: "CE",
  },
  {
    label: "DF",
    value: "DF",
  },
  {
    label: "ES",
    value: "ES",
  },
  {
    label: "GO",
    value: "GO",
  },
  {
    label: "MA",
    value: "MA",
  },
  {
    label: "MT",
    value: "MT",
  },
  {
    label: "MS",
    value: "MS",
  },
  {
    label: "MG",
    value: "MG",
  },
  {
    label: "PA",
    value: "PA",
  },
  {
    label: "PB",
    value: "PB",
  },
  {
    label: "PR",
    value: "PR",
  },
  {
    label: "PE",
    value: "PE",
  },
  {
    label: "PI",
    value: "PI",
  },
  {
    label: "RJ",
    value: "RJ",
  },
  {
    label: "RN",
    value: "RN",
  },
  {
    label: "RS",
    value: "RS",
  },
  {
    label: "RO",
    value: "RO",
  },
  {
    label: "RR",
    value: "RR",
  },
  {
    label: "SC",
    value: "SC",
  },
  {
    label: "SP",
    value: "SP",
  },
  {
    label: "SE",
    value: "SE",
  },
  {
    label: "TO",
    value: "TO",
  }
];


const ZipcodeRangeList = () => {
  const { auth } = store.getState();
  const { user } = auth;
  const history = useHistory()

  const api = new BrComerceApiService();

  const [ranges, setRanges] = useState([]);

  const [loading, setLoading] = useState(false);
  const [actualPage, setActualPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [resultsPages, setResultsPages] = useState({ label: "10", value: 10 });
  const [selectedType, setSelectedType] = useState({ label: "Super Expresso", value: 1 });
  const [originUf, setOriginUf] = useState({
    label: "Selecione a UF de origem",
    value: ""
  },);
  const [destinationUf, setDestinationUf] = useState({
    label: "Selecione a UF de destino",
    value: ""
  },);
  const [active, setActive] = useState({
    label: "Selecione a disponibilidade",
    value: ""
  },);


  const activeOptions = [
    {
      label: "Selecione",
      value: ""
    },
    {
      label: "Ativado",
      value: "true",
    },
    {
      label: "Desativado",
      value: "false",
    },
  ]

  const handleSelectedType = useCallback((value) => {
    setRanges([]);
    setActualPage(1);
    setTotalPages(0);
    setResultsPages({ label: "10", value: 10 });
    setSelectedType(value);
  }, [])

  const useZipCode = (initialState = "vazio") => {
    const [zipCodeOK, setZipCodeOK] = useState(initialState);
    const [zipCodeError, setZipCodeError] = useState("");
    const [zipCode, setZipCode] = useState("");
    const [zipCodeFilter, setZipCodeFilter] = useState("");

    const handleValidationZipCode = useCallback((value) => {
      if (value.length === 0) {
        setZipCodeOK("ok");
        setZipCodeError("");
      } else if (value.length < 9) {
        setZipCodeOK("notOk");
        setZipCodeError("Preenchimento incorreto");
      } else {
        setZipCodeOK("ok");
        setZipCodeError("");
      }
    }, []);

    const handleZipCode = useCallback(async (e) => {
      e.currentTarget.maxLength = 9;
      let value = e.currentTarget.value;

      value = value.replace(/\D/g, "");
      value = value.replace(/^(\d{5})(\d{3})/, "$1-$2");

      handleValidationZipCode(value);
      e.currentTarget.value = value;
      setZipCode(value);
    }, [handleValidationZipCode]);

    return {
      zipCodeOK,
      setZipCodeOK,
      zipCodeError,
      setZipCodeError,
      zipCode,
      setZipCode,
      zipCodeFilter,
      setZipCodeFilter,
      handleZipCode,
    };
  };

  const useZipCodeDestination = (initialState = "vazio") => {
    const [zipCodeDestinationOK, setZipCodeDestinationOK] = useState(initialState);
    const [zipCodeDestinationError, setZipCodeDestinationError] = useState("");
    const [zipCodeDestination, setZipCodeDestination] = useState("");
    const [zipCodeDestinationFilter, setZipCodeDestinationFilter] = useState("");

    const handleValidationZipCodeDestination = useCallback((value) => {
      if (value.length === 0) {
        setZipCodeDestinationOK("ok");
        setZipCodeDestinationError("");
      } else if (value.length < 9) {
        setZipCodeDestinationOK("notOk");
        setZipCodeDestinationError("Preenchimento incorreto");
      } else {
        setZipCodeDestinationOK("ok");
        setZipCodeDestinationError("");
      }
    }, []);

    const handleZipCodeDestination = useCallback(async (e) => {
      e.currentTarget.maxLength = 9;
      let value = e.currentTarget.value;

      value = value.replace(/\D/g, "");
      value = value.replace(/^(\d{5})(\d{3})/, "$1-$2");

      handleValidationZipCodeDestination(value);
      e.currentTarget.value = value;
      setZipCodeDestination(value);
    }, [handleValidationZipCodeDestination]);

    return {
      zipCodeDestinationOK,
      setZipCodeDestinationOK,
      zipCodeDestinationError,
      setZipCodeDestinationError,
      zipCodeDestination,
      setZipCodeDestination,
      zipCodeDestinationFilter,
      setZipCodeDestinationFilter,
      handleZipCodeDestination,
    };
  };

  const {
    zipCodeOK,
    zipCodeError,
    zipCode,
    zipCodeFilter,
    setZipCodeFilter,
    handleZipCode,
  } = useZipCode();

  const {
    zipCodeDestinationOK,
    zipCodeDestinationError,
    zipCodeDestination,
    zipCodeDestinationFilter,
    setZipCodeDestinationFilter,
    handleZipCodeDestination,
  } = useZipCodeDestination();

  const formatZipCode = (value) => {
    return value.replace('-', '');
  }

  const loadRanges = useCallback(
    debounce(async params => {
      try {
        setLoading(true);

        console.log({ params })
        let response;

        if (selectedType.value === 1) {

          response = await api.makeHttpRequest({
            url: '/rates',
            params: {
              page: params?.page ?? 1,
              resultsPerPage: params?.resultsPages ?? 10,
              ...(params?.zipCode && { zip: formatZipCode(params.zipCode) }),
            }
          });
        } else {
          response = await api.makeHttpRequest({
            url: '/zipcode-ranges',
            params: {
              page: params?.page ?? 1,
              resultsPerPage: params?.resultsPages ?? 10,
              code: selectedType.value,
              ...(params?.originUf && { originUf: params.originUf }),
              ...(params?.destinationUf && { destinationUf: params.destinationUf }),
              ...(params?.originZipcode && { originZipcode: formatZipCode(params.originZipcode) }),
              ...(params?.destinationZipcode && { destinationZipcode: formatZipCode(params.destinationZipcode) }),
              ...(params?.active && { active: params.active }),
            }
          });
        }

        setActualPage(response.actualPage);
        setTotalPages(response.nPages);
        setRanges(response.results);
      } catch (e) {
        Swal.fire({
          text: "Erro ao carregar lista de faixas de cep",
          title: "Faixas de CEP",
          icon: "error"
        });
      } finally {
        setLoading(false);
      }
    }, 500),
    [ranges, selectedType]
  );

  const handleAction = async (id, status) => {
    Swal.fire({
      title: "Você tem certeza?",
      html:
        `Deseja prosseguir com a ${status ? 'ativação' : 'desativação'} da faixa de cep?`,
      icon: "warning",
      cancelButtonText: "Cancelar",
      showCancelButton: true,
      confirmButtonText: `Sim, fazer a ${status ? 'ativação' : 'desativação'}!`
    }).then(response => {
      if (response?.value) {
        handleOnConfirmAction(id, status);
      }
    });
  };

  const handleOnConfirmAction = async (id, status) => {
    try {
      setLoading(true);

      if (selectedType.value === 1) {

        await api.makeHttpRequest({
          method: "PUT",
          url: '/rates',
          data: {
            id, status
          }
        });
      } else {
        await api.makeHttpRequest({
          method: "PUT",
          url: `/zipcode-ranges/${id}`,
          data: {
            active: status
          }
        });
      }
    } catch (error) {
      Swal.fire({
        text: `Erro ao ${status ? 'ativar' : 'desativar'} faixa de cep`,
        title: "Faixa de CEP",
        icon: "error"
      });
    } finally {
      setLoading(true);
      if (selectedType.value === 1) {
        loadRanges({
          page: actualPage,
          resultsPage: resultsPages.value,
        });
      } else {
        loadRanges({
          page: actualPage,
          resultsPage: resultsPages.value,
          code: selectedType.value
        })
      }
    }
  }

  const onPage = newPage => {
    setActualPage(newPage - 1);
  };

  const onNext = () => {
    setLoading(true);
    onPage(actualPage + 1);
    setActualPage(actualPage + 1);
  };

  const onPrevious = () => {
    setLoading(true);
    onPage(actualPage - 1);
    setActualPage(actualPage - 1);
  };

  const perPageOptions = [
    {
      label: "10",
      value: 10
    },
    {
      label: "15",
      value: 15
    },
    {
      label: "20",
      value: 20
    },
    {
      label: "50",
      value: 50
    },
    {
      label: "100",
      value: 100
    }
  ];

  useEffect(() => {
    if (user.profile !== "admin") {
      history.push("/");
    }
  }, []);

  useEffect(() => {
    if (zipCode.length === 9) {
      setZipCodeFilter(zipCode)
      setActualPage(1)
    } else {
      setZipCodeFilter("")
    }
  }, [zipCode]);

  useEffect(() => {
    if (zipCodeDestination.length === 9) {
      setZipCodeDestinationFilter(zipCodeDestination)
      setActualPage(1)
    } else {
      setZipCodeDestinationFilter("")
    }
  }, [zipCodeDestination]);

  useEffect(() => {
    if (selectedType.value === 1) {

      loadRanges({
        page: actualPage,
        resultsPages: resultsPages.value,
        zipCode: zipCodeFilter,
      });
    } else {
      loadRanges({
        page: actualPage,
        resultsPages: resultsPages.value,
        code: selectedType.value,
        originUf: originUf.value,
        destinationUf: destinationUf.value,
        originZipcode: zipCodeFilter,
        destinationZipcode: zipCodeDestinationFilter,
        active: active.value
      });
    }
  }, [actualPage, resultsPages, zipCodeFilter, zipCodeDestinationFilter, originUf, destinationUf, active]);

  useEffect(() => {
    window.setPageTitle("Gestão de CEPS");
  }, []);

  return (
    <>
      <Loading isLoading={loading} />
      <Container title="Gestão de CEPs">
        <div className={styles.contentBody}>
          <div className={styles.filters}>
            {selectedType.value !== 1
              ? <>
                <div className={styles.filtersContainers}>
                  <div className={styles.filtersContainersInput}>
                    <Select
                      onChange={(e) => handleSelectedType(e)}
                      options={typesOptions}
                      value={selectedType}
                      placeholder="Selecione o tipo"
                      styles={selectStyle}
                    />
                    <div className={styles.filterInput} role={zipCodeOK}>
                      <div className={styles.input} role={zipCodeOK}>
                        <input
                          type="text"
                          name="zipCodeStart"
                          placeholder="Filtre pelo CEP de origem. Ex: 99999-999"
                          value={zipCode}
                          onChange={e => handleZipCode(e)}
                        />
                      </div>
                      {zipCodeError && <p className={styles.error}>{zipCodeError}</p>}
                    </div>
                    <div className={styles.filterInput} role={zipCodeDestinationOK}>
                      <div className={styles.input} role={zipCodeDestinationOK}>
                        <input
                          type="text"
                          name="zipCodeDestination"
                          placeholder="Filtre pelo CEP de destino. Ex: 99999-999"
                          value={zipCodeDestination}
                          onChange={e => handleZipCodeDestination(e)}
                        />
                      </div>
                      {zipCodeDestinationError && <p className={styles.error}>{zipCodeDestinationError}</p>}
                    </div>
                  </div>
                  <div className={styles.filtersContainersSelect}>

                    <Select
                      onChange={(e) => setOriginUf(e)}
                      options={ufsOptions}
                      value={originUf}
                      placeholder="Selecione a UF de origem"
                      styles={selectStyle}
                    />
                    <Select
                      onChange={(e) => setDestinationUf(e)}
                      options={ufsOptions}
                      value={destinationUf}
                      placeholder="Selecione a UF de destino"
                      styles={selectStyle}
                    />
                    <Select
                      onChange={(e) => setActive(e)}
                      options={activeOptions}
                      value={active}
                      placeholder="Selecione a disponibilidade"
                      styles={selectStyle}
                    />
                    <Link to="/gestao-ceps/create-range">
                      <button type="button" className={styles.btnAddRange}>
                        <FaCirclePlus fill="#fff" color="#fff" />
                        <span>Criar nova faixa de cep</span>
                      </button>
                    </Link>
                  </div>
                </div>
              </>
              : <>
                <Select
                  onChange={(e) => handleSelectedType(e)}
                  options={typesOptions}
                  value={selectedType}
                  placeholder="Selecione o tipo"
                  styles={selectStyle}
                />
                <div className={styles.filterInput} role={zipCodeOK}>
                  <div className={styles.input} role={zipCodeOK}>
                    <input
                      type="text"
                      name="zipCodeStart"
                      placeholder="Filtre pelo CEP. Ex: 99999-999"
                      value={zipCode}
                      onChange={e => handleZipCode(e)}
                    />
                  </div>
                  {zipCodeError && <p className={styles.error}>{zipCodeError}</p>}
                </div>
                <Link to="/gestao-ceps/create-range">
                  <button type="button" className={styles.btnAddRange}>
                    <FaCirclePlus fill="#fff" color="#fff" />
                    <span>Criar nova faixa de cep</span>
                  </button>
                </Link>
              </>
            }
          </div>
          <div className={styles.contentTable}>
            {selectedType.value === 1 ?
              <table className={styles.tableContainer}>
                <thead>
                  <tr>
                    <th width="10%">Faixa Inicial</th>
                    <th width="10%">Faixa Final</th>
                    <th width="3%">Ações</th>
                  </tr>
                </thead>
                <tbody>
                  {!!ranges.length &&
                    ranges.map(range => {
                      return (
                        <tr key={range.id}>
                          <td>{formatCep(range?.zipStart.toString())}</td>
                          <td>{formatCep(range?.zipEnd.toString())}</td>
                          <td className={styles.tooltipWrapper}>
                            <Switch
                              checked={range.active}
                              onChange={() =>
                                handleAction(range.id, !range.active)
                              }
                              offColor="#B3B3B3"
                              onColor="#409E6A"
                              offHandleColor="#FFF"
                              onHandleColor="#FFF"
                              uncheckedIcon={false}
                              checkedIcon={false}
                              width={45}
                              height={23}
                              handleDiameter={13}
                            />
                          </td>
                        </tr>
                      );
                    })}
                </tbody>
              </table>
              : <table className={styles.tableContainer}>
                <thead>
                  <tr>
                    <th width="10%">UF de Origem</th>
                    <th width="10%">Faixa de Origem Inicial</th>
                    <th width="10%">Faixa de Origem Final</th>
                    <th width="10%">UF de Destino</th>
                    <th width="10%">Faixa de Destino Inicial</th>
                    <th width="10%">Faixa de Destino Final</th>
                    <th width="10%">Prazo de entrega</th>
                    <th width="3%">Ações</th>
                  </tr>
                </thead>
                <tbody>
                  {!!ranges.length &&
                    ranges.map(range => {
                      return (
                        <tr key={range.id}>
                          <td>{formatCep(range?.originUf.toString())}</td>
                          <td>{formatCep(range?.originStart.toString())}</td>
                          <td>{formatCep(range?.originEnd.toString())}</td>
                          <td>{formatCep(range?.destinationUf.toString())}</td>
                          <td>{formatCep(range?.destinationStart.toString())}</td>
                          <td>{formatCep(range?.destinationEnd.toString())}</td>
                          <td>{formatCep(range?.sla.toString())}</td>
                          <td className={styles.tooltipWrapper}>
                            <Switch
                              checked={range.active}
                              onChange={() =>
                                handleAction(range.id, !range.active)
                              }
                              offColor="#B3B3B3"
                              onColor="#409E6A"
                              offHandleColor="#FFF"
                              onHandleColor="#FFF"
                              uncheckedIcon={false}
                              checkedIcon={false}
                              width={45}
                              height={23}
                              handleDiameter={13}
                            />
                          </td>
                        </tr>
                      );
                    })}
                </tbody>
              </table>
            }
            <div className={styles.paginationContainer}>
              <div className={styles.perPageContent}>
                <span>Itens por página:</span>
                <Select
                  styles={selectPageStyle}
                  value={resultsPages}
                  options={perPageOptions}
                  onChange={e => setResultsPages(e)}
                  menuPlacement="top"
                />
              </div>
              <h6>
                {actualPage} - {resultsPages.value} de {totalPages}
              </h6>
              <div className={styles.controlPage}>
                <FiChevronLeft
                  size={25}
                  onClick={actualPage > 1 ? onPrevious : ""}
                  color={actualPage > 1 ? "#409E6A" : "#2D724C"}
                  className="arrow"
                />
                <FiChevronRight
                  size={25}
                  onClick={actualPage < totalPages ? onNext : ""}
                  color={actualPage < totalPages ? "#409E6A" : "#2D724C"}
                  className="arrow"
                />
              </div>
            </div>
          </div>
        </div>
      </Container>
    </>
  )
}

export { ZipcodeRangeList }
